module.exports = __webpack_public_path__ + "MaterialIcons-Regular.570eb83859dc23dd0eec.woff2";


//////////////////
// WEBPACK FOOTER
// /app/src/assets/layout/fonts/MaterialIcons-Regular.woff2
// module id = ../../../../../src/assets/layout/fonts/MaterialIcons-Regular.woff2
// module chunks = 2